import React, { FC } from 'react'

import { CardsGrid } from './CardsGrid'
import { useWindowSize } from 'core/hooks/useWindowSize'
import SoundscapeGradientCard from 'components/soundscape-gradient-card/SoundscapeGradientCard'

import classes from './ShowcaseFeatureDisplay.module.scss'

interface FeatureCardData {
  icon?: string
  text?: string
}

interface ShowcaseFeatureDisplayProps {
  desktopBackgroundUrl: string
  mobileBackgroundUrl: string
  cards: FeatureCardData[]
}

export const ShowcaseFeatureDisplay: FC<ShowcaseFeatureDisplayProps> = ({
  desktopBackgroundUrl,
  mobileBackgroundUrl,
  cards,
}) => {
  const { width } = useWindowSize()
  const isTablet = width <= 1203

  return (
    <>
      {isTablet ? <SoundscapeGradientCard /> : null}
      <div
        className={classes.container}
        style={
          {
            '--desktop-bg': `url(${desktopBackgroundUrl})`,
            '--mobile-bg': `url(${mobileBackgroundUrl})`,
          } as React.CSSProperties
        }
      >
        {!isTablet ? (
          <>
            <SoundscapeGradientCard />
            <CardsGrid cards={cards} />
          </>
        ) : null}
      </div>
      {isTablet ? <CardsGrid cards={cards} /> : null}
    </>
  )
}
